<template>
    <div class="jianbao_box">
        <m-title></m-title>
        <div class="cont">
            <div class="changdi">
                <div class="changditop">
                    <div class="changdi_left">
                        <span class="name">计划来源</span>
                        <div class="select_box">
                            <el-select v-model="changdival" placeholder="请选择" @input="changdiselect">
                                <el-option v-for="it in changdisel" :key="it.value" :value="it.value"
                                    :label="it.label"></el-option>
                            </el-select>
                        </div>
                        <!-- <span class="name">货物</span> -->
                        <!-- <el-input placeholder="请输入" type="text" v-model="goodsname" class="inp" /> -->
                        <span class="name">货主</span>
                        <el-input placeholder="请输入" type="text" v-model="customname" class="inp" />
                        <span class="name">货代</span>
                        <el-input placeholder="请输入" type="text" v-model="agentname" class="inp" />
                        <span class="name">船名</span>
                        <el-input placeholder="请输入" type="text" v-model="shipname" class="inp" />
                        <span class="name">车队</span>
                        <el-input placeholder="请输入" type="text" v-model="fleetname" class="inp" />
                    </div>

                </div>
                <div class="changdibtn">
                    <div class="left">
                        <div v-for="item in ywtype" :key="item.type" :class="[type == item.type ? 'active' : 'ywstyle']"
                            @click="checkywindex(item.type)">{{
                                item.name }}</div>
                        <span class="name">日期</span>
                        <el-date-picker v-model="starttime" type="date" class="inp" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="请选择">
                        </el-date-picker>
                        <span class="name" style="margin-left: 0;">至</span>
                        <el-date-picker v-model="endtime" type="date" class="inp" value-format="yyyy-MM-dd HH:mm:ss"
                            placeholder="结束时间">
                        </el-date-picker>
                    </div>

                    <div class="clear_search">
                        <button class="chaxun" @click="getsearch">查询</button>
                        <button class="reset" @click="reset">重置</button>
                    </div>
                </div>
            </div>
            <div class="zuoyejianbao">
                <div class="echarts-title">
                    <div class="left">
                        <div class="left-bac"></div>
                        <div class="left-name">计划详情</div>
                    </div>
                    <div class="right">
                        <div class="r-txt">预派车兑现率 = 实际运输车数 / 预派车数</div>
                        <div class="r-txt">实际派车兑现率 = 实际运输车数 / 派车数</div>
                    </div>
                </div>
                <div class="zuoyedetail">
                    <el-table style="width: 100%; height: 100%;" :data="pnolist.list" @cell-click="getchedui" border
                        :cell-style="cellStyle" highlight-current-row>
                        <el-table-column label="序号" type="index" width="50px" />
                        <el-table-column prop="time" label="日期" show-overflow-tooltip />
                        <el-table-column prop="shortname" label="车队名" show-overflow-tooltip />
                        <el-table-column prop="shipname" label="船名" show-overflow-tooltip />
                        <el-table-column prop="customname" label="货主" show-overflow-tooltip />
                        <el-table-column prop="agentname" label="货代" show-overflow-tooltip />
                        <el-table-column prop="pno" label="计划号" show-overflow-tooltip />
                        <el-table-column prop="carRegistCount" label="车队车数" show-overflow-tooltip />
                        <el-table-column prop="yuyueCarCount" label="预派车数" show-overflow-tooltip />
                        <el-table-column prop="dispathCount" label="派车数" show-overflow-tooltip />
                        <el-table-column prop="carWorkedCount" label="实际运输车数" show-overflow-tooltip />
                        <el-table-column prop="yuyueCarRate" label="预派车兑现率" show-overflow-tooltip>
                            <template v-slot="res">
                                <span>{{ (res.row.yuyueCarRate * 100).toFixed(2) }}%</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="dispathRate" label="实际派车兑现率" show-overflow-tooltip>
                            <template v-slot="res">
                                <span>{{ (res.row.dispathRate * 100).toFixed(2) }}%</span>
                            </template>
                        </el-table-column>
                        <!-- <el-table-column label="完成时间" show-overflow-tooltip>
                            <template v-slot="res">
                                <span>{{ mydateFormat(res.row.endworkdate, '时分秒') }}</span>
                            </template>
                        </el-table-column> -->
                    </el-table>
                    <el-pagination :page-size="limit" layout="total,prev, pager,next, jumper" :total="pnolist.total"
                        :current-page="memberlistpno.page" @current-change="CurrentChangeJH"
                        style="text-align: center;">
                    </el-pagination>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import mTitle from '@/components/mTitle.vue';
import dayjs from 'dayjs';
export default {
    data() {
        return {
            changdisel: [
                { label: "前沿货场", value: "jiaotan" },
                { label: "港俊货场", value: "gangjun" },
                { label: "昊德", value: "haode" },
                { label: "琦晟", value: "qisheng" },
                { label: "睿鑫", value: "ruixin" },
                { label: "通达", value: "tongda" },
                { label: "富泉", value: "fuquan" },
            ],
            changdival: "jiaotan",
            ywtype: [
                // { name: "本日", type: 1 },
                { name: "近一周", type: 2 },
                { name: "近一月", type: 3 },
                { name: "近一年", type: 4 },
                { name: "昨日", type: 5 },
            ],
            type: 2,
            // goodsname: null,
            customname: null,
            agentname: null,
            shipname: null,
            starttime: null,
            endtime: null,
            pnolist: [],
            memberlistpno: {
                page: 1,
            },
            limit: 20,
            fleetname: "",
            obj: {},
        }
    },
    components: {
        mTitle,
    },
    watch: {
        type: {
            handler(a, b) {
                const today = new Date().getTime()
                let week = today - 6 * 24 * 3600 * 1000
                let month = today - 29 * 24 * 3600 * 1000
                let year = today - 364 * 24 * 3600 * 1000
                this.endtime = dayjs(today).format('YYYY-MM-DD HH:mm:ss')
                switch (a) {
                    case 2:
                        this.starttime = dayjs(week).format('YYYY-MM-DD 00:00:00')
                        break;
                    case 3:
                        this.starttime = dayjs(month).format('YYYY-MM-DD 00:00:00')
                        break;
                    case 4:
                        this.starttime = dayjs(year).format('YYYY-MM-DD 00:00:00')
                        break;
                    case 5:
                        this.starttime = dayjs().subtract(1, 'day').format('YYYY-MM-DD 00:00:00')
                        this.endtime = dayjs().subtract(1, 'day').format('YYYY-MM-DD 23:59:59')
                        break;
                }
            }
        },
        // starttime:{
        //     handler(a){
        //         if(a){
        //             this.type=null
        //         }
        //     }
        // }
    },
    created() {
        const today = new Date().getTime()
        let week = today - 6 * 24 * 3600 * 1000
        this.endtime = dayjs(today).format('YYYY-MM-DD HH:mm:ss')
        this.starttime = dayjs(week).format('YYYY-MM-DD 00:00:00')
        if (this.$route.query.obj) {
            this.goodsname = JSON.parse(this.$route.query.obj).goodsname
            this.shipname = JSON.parse(this.$route.query.obj).shipname
            this.fleetname = JSON.parse(this.$route.query.obj).fleetname
            this.changdival = JSON.parse(this.$route.query.obj).stname
            this.type = JSON.parse(this.$route.query.obj).type
            this.starttime = JSON.parse(this.$route.query.obj).startTime
            this.endtime = JSON.parse(this.$route.query.obj).endTime
        }

    },
    mounted() {
        this.getsearch()
    },

    methods: {
        checkywindex(index) {
            this.type = index
        },
        //选择货场
        changdiselect(e) {
            this.changdival = e
        },
        //查询
        getsearch() {
            this.getpnolist()
        },
        //重置
        reset() {
            this.changdival = "jiaotan"
            this.pno = null
            this.goodsname = null
            this.shipname = null
            this.starttime = null
            this.endtime = null
            this.agentname=null
            this.customname=null
            this.fleetname = ""
            this.memberlistpno.page = 1
            this.getsearch()
        },
        CurrentChangeJH(e) {
            this.memberlistpno.page = e
            this.getpnolist()
        },
        //查询计划
        async getpnolist() {
            const { data } = await this.$http(
                "api1",
                "/home/statistics/homeCarWorkSearch",
                "get",
                {
                    stname: this.changdival,
                    pno: this.pno,
                    // cargoname: this.goodsname,
                    shipname: this.shipname,
                    agentname: this.agentname,
                    customname: this.customname,
                    starttime: this.starttime,
                    fleetname: this.fleetname,
                    endtime: this.endtime,
                    limit: this.limit,
                    // type:this.type,
                    page: this.memberlistpno.page
                }
            );
            if (data.code != 0) return this.$message.error(data.msg);

            this.pnolist = data.data;
        },
        getchedui(row, column, cell, event) {
            if (column.label === "实际运输车数") {
                this.$router.push({ name: "homemapdetail", query: { obj: JSON.stringify(row) } })
            } else if (column.label === "计划号") {
                this.$router.push({ name: "zuoyechaxun", query: { obj: JSON.stringify({ fleetname: row.shortname, pno: row.pno }) } })
            }
        },
        cellStyle({ row, column, rowIndex, columnIndex }) {

            if (column.label === "实际运输车数" || column.label === "计划号") {
                return "font-weight:700;color:#FF6100;cursor: pointer;";
            }
            return "";
        }
    },
}
</script>

<style lang="scss" scoped>
.el-table .warning-row {
    background: oldlace;
}

.jianbao_box {

    width: 100%;
    height: 100%;

    .cont {
        position: relative;
        width: 100%;
        height: calc(100% - 50px);
        background-color: #f5f6fa;
        padding: 10px;
        box-sizing: border-box;
        padding-top: 0;
        overflow: hidden;

        .changdi {
            width: 100%;
            background-color: #fff;
            padding: 20px;
            box-sizing: border-box;
            border-radius: 8px;

            .changditop {

                display: flex;
                justify-content: space-between;
                align-items: center;
                margin-bottom: 20px;

                .changdi_left {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .inp {
                        width: 150px;
                        height: 30px;
                    }

                    .name {
                        font-size: 14px;
                        margin: 0 10px;
                    }

                    .select_box {
                        display: inline-block;
                        font-weight: 400;
                        width: 120px;
                        height: 30px;
                        vertical-align: middle;
                        margin-left: 10px;
                        background: #f3f4f5;
                        line-height: 30px;
                    }

                }


            }

            .changdibtn {
                display: flex;
                justify-content: space-between;

                .clear_search {

                    .chaxun {
                        width: 80px;
                        height: 30px;
                        background: #17B6A1;
                        border-radius: 8px;
                        color: #fff;
                        line-height: 30px;
                        text-align: center;
                        border: none;
                        font-size: 80%;
                    }

                    .reset {
                        width: 80px;
                        height: 30px;
                        background-color: #F5F6FA;
                        border-radius: 8px;
                        color: #17B6A1;
                        line-height: 30px;
                        text-align: center;
                        border: none;
                        font-size: 80%;
                        margin-left: 19px;
                    }
                }

                .left {
                    display: flex;
                    align-items: center;

                    .inp {
                        width: 150px;
                        height: 30px;
                    }

                    .name {
                        font-size: 14px;
                        margin: 0 10px;
                    }

                    .ywstyle {
                        width: 80px;
                        height: 30px;
                        border: 1px solid #17B6A1;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 16px;
                        color: #17B6A1;
                        margin-left: 15px;
                        cursor: pointer;
                    }

                    .active {
                        width: 80px;
                        height: 30px;
                        border: 1px solid #17B6A1;
                        border-radius: 4px;
                        text-align: center;
                        line-height: 30px;
                        font-size: 16px;
                        color: #fff;
                        background-color: #17B6A1;
                        margin-left: 15px;
                        cursor: pointer;
                    }
                }

            }
        }

        .zuoyejianbao {
            width: 100%;
            height: calc(100% - 130px);
            background: #FFFFFF;
            border-radius: 8px;
            margin-top: 20px;
            padding: 0 34px;
            box-sizing: border-box;

            .echarts-title {
                padding: 10px 0;
                box-sizing: border-box;
                display: flex;
                justify-content: space-between;
                align-items: center;

                .left {
                    display: flex;
                    justify-content: flex-start;
                    align-items: center;

                    .left-bac {
                        width: 12px;
                        height: 26px;
                        background: #17B6A1;
                        border-radius: 6px;
                        margin-right: 11px;
                    }

                    .left-name {
                        font-size: 100%;
                        font-family: PingFang SC;
                        font-weight: 600;
                        color: #2D3748;
                    }
                }

                .right {
                    display: flex;
                    justify-content: flex-end;
                    align-items: center;

                    .r-txt {
                        font-size: 80%;
                        color: #c00000;
                        margin-right: 20px;
                    }
                }
            }

            .zuoyedetail {
                padding-bottom: 10px;
                height: 80%;
            }

        }
    }

}
</style>